import api from '@/api/api';

export default {

  namespaced: true,

  state: {
  },
  mutations: {

  },
  actions: {
    async updatePassworPaso1({
      commit,
    },pass) {
      try {
        const res = await api.updatePassworPaso1(pass);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
        //   commit('getContrato', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async updatePasswordPaso2({
      commit,
    },pass) {
      try {
        const res = await api.updatePasswordPaso2(pass);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
        //   commit('getContrato', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },








  },
};
